module.exports = "https://cdn-b2c.dom.ru/b2c-domru/2.358.9/frontend/_next/static/images/domofon-2-ea63f79911560340b024b9493ecdd835.webp";